import React from 'react';
import Category from "./Category";
import { useAppDispatch, useAppSelector } from '../redux/hooks'
const Article = ({ result, id }) => {

    const categoriesLabel = useAppSelector((state) => state.pageSettings.categoriesText);
    const article = result;

    return (
        <li key={article.index} className="otc-listing-article" id={id}>
            <div className="otc-listing-article-content">
                <div className="otc-listing-article-content-info stack-sm">
                    <p className="otc-listing-article-date"> {article.dateDisplay}</p>
                    <a href={article.url} className="otc-listing-article-title h6-style space-top-xs" target="_blank"> {article.title} </a>
                    {article.author &&
                        <p className="label"> {article.author}</p>
                    }
                    {article.membersOnly &&
                        <p className="event-tags-item event-tag tag-member">Members Only</p>
                    }
                    <div dangerouslySetInnerHTML={{ __html: article.synopsis }} />


                    {article.categories.length > 0 && article.categories.filter(c => c.hideCategory == false).length > 0 &&

                        <ul className="otc-listing-categories">
                            <li className="bold otc-listing-categories-tag"> {categoriesLabel} </li>
                            {article.categories.filter(c => c.hideCategory == false).map(category => (
                                <li className="otc-listing-categories-tag bold" key={category.id}>
                                    {category.url != "" ?
                                        <>
                                            <a className="cta-link-otc" href={category.url}> {category.description} </a>
                                        </>
                                        : <p className="cta-span-otc"> {category.description}</p>
                                    }
                                </li>
                            ))
                            }
                        </ul>
                    }

                </div>
                <div className="otc-listing-article-image">
                    <a className="unlink" href={article.url} target="_blank">
                        <img src={article.imageUrl} alt={article.imageAltText} />
                    </a>
                </div>
            </div>
        </li>
    );
}


export default React.memo(Article);